module.exports = [{
      plugin: require('/portfolio/node_modules/gatsby-plugin-transition-link/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/portfolio/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
